export const NOMINATED = 'nominated';
export const ASSIGNED = 'assigned';
export const ALL = 'all';
export const LIVE_CHAT = 'live_chat';
export const REVIEW = 'review';
